import React from 'react';
import { useTranslation } from 'react-i18next';
import { Card, Form, Input } from 'antd';
import CountrySelect from '../form/address/CountrySelect';

/**
 * @param {string[]} [fields] When provided, only the fields whose name is in the
 * array are rendered; otherwise every field is shown.
 */
export default function BusinessInfo({ data, hasSetupFee, fields, children, onChange }) {
  const { t } = useTranslation(undefined, { keyPrefix: 'Components:Contract:BusinessInfo' });

  const isVisible = (name) => !fields || fields.includes(name);

  return (
    <Card>
      <h6 className="underline">{t('sections.business_info')}</h6>
      <Form layout="vertical" className="mt-md">
        {isVisible('company_name') && (
          <Form.Item label={t('form.company_name.label')}>
            <Input
              value={data.company_name}
              onChange={(e) => onChange('company_name', e.target.value)}
              placeholder={t('form.company_name.placeholder')}
            />
          </Form.Item>
        )}
        {isVisible('business_name') && (
          <Form.Item label={t('form.business_name.label')}>
            <Input
              value={data.business_name}
              onChange={(e) => onChange('business_name', e.target.value)}
              placeholder={t('form.business_name.placeholder')}
            />
          </Form.Item>
        )}
        {isVisible('owner_full_name') && (
          <Form.Item label={t('form.owner_full_name.label')}>
            <Input
              value={data.owner_full_name}
              onChange={(e) => onChange('owner_full_name', e.target.value)}
              placeholder={t('form.owner_full_name.placeholder')}
            />
          </Form.Item>
        )}
        {isVisible('business_address') && (
          <Form.Item label={t('form.business_address.label')}>
            <Input
              value={data.business_address}
              onChange={(e) => onChange('business_address', e.target.value)}
              placeholder={t('form.business_address.placeholder')}
            />
          </Form.Item>
        )}
        {isVisible('business_zip_code') && (
          <Form.Item label={t('form.business_zip_code.label')}>
            <Input
              value={data.business_zip_code}
              onChange={(e) => onChange('business_zip_code', e.target.value)}
              placeholder={t('form.business_zip_code.placeholder')}
            />
          </Form.Item>
        )}
        {isVisible('business_city') && (
          <Form.Item label={t('form.business_city.label')}>
            <Input
              value={data.business_city}
              onChange={(e) => onChange('business_city', e.target.value)}
              placeholder={t('form.business_city.placeholder')}
            />
          </Form.Item>
        )}
        {isVisible('business_country') && (
          <Form.Item label={t('form.business_country.label')}>
            <CountrySelect
              value={data.business_country}
              onChange={(value) => onChange('business_country', value)}
              placeholder={t('form.business_country.placeholder')}
            />
          </Form.Item>
        )}
        {isVisible('company_phone_number') && (
          <Form.Item label={t('form.company_phone_number.label')}>
            <Input
              value={data.company_phone_number}
              onChange={(e) => onChange('company_phone_number', e.target.value)}
              placeholder={t('form.company_phone_number.placeholder')}
              type="tel"
            />
          </Form.Item>
        )}
        {isVisible('contact_person_full_name') && (
          <Form.Item label={t('form.contact_person_full_name.label')}>
            <Input
              value={data.contact_person_full_name}
              onChange={(e) => onChange('contact_person_full_name', e.target.value)}
              placeholder={t('form.contact_person_full_name.placeholder')}
            />
          </Form.Item>
        )}
        {isVisible('contact_person_phone_number') && (
          <Form.Item label={t('form.contact_person_phone_number.label')}>
            <Input
              value={data.contact_person_phone_number}
              onChange={(e) => onChange('contact_person_phone_number', e.target.value)}
              placeholder={t('form.contact_person_phone_number.placeholder')}
              type="tel"
            />
          </Form.Item>
        )}
        {isVisible('contact_person_email') && (
          <Form.Item label={t('form.contact_person_email.label')}>
            <Input
              value={data.contact_person_email}
              onChange={(e) => onChange('contact_person_email', e.target.value)}
              placeholder={t('form.contact_person_email.placeholder')}
              type="email"
            />
          </Form.Item>
        )}
        {isVisible('business_tax_id') && (
          <Form.Item label={t('form.business_tax_id.label')}>
            <Input
              value={data.business_tax_id}
              onChange={(e) => onChange('business_tax_id', e.target.value)}
              placeholder={t('form.business_tax_id.placeholder')}
            />
          </Form.Item>
        )}
      </Form>
      {hasSetupFee && (
        <div className="mt-lg">
          <h6 className="underline mt-md">{t('sections.bank_info')}</h6>
          <Form layout="vertical">
            {isVisible('business_bank_account_holder_name') && (
              <Form.Item label={t('form.business_bank_account_holder_name.label')}>
                <Input
                  value={data.business_bank_account_holder_name}
                  onChange={(e) => onChange('business_bank_account_holder_name', e.target.value)}
                  placeholder={t('form.business_bank_account_holder_name.placeholder')}
                />
              </Form.Item>
            )}
            {isVisible('business_bank_account_number') && (
              <Form.Item label={t('form.business_bank_account_number.label')}>
                <Input
                  value={data.business_bank_account_number}
                  onChange={(e) => onChange('business_bank_account_number', e.target.value)}
                  placeholder={t('form.business_bank_account_number.placeholder')}
                />
              </Form.Item>
            )}
            {isVisible('business_bank_routing_number') && (
              <Form.Item label={t('form.business_bank_routing_number.label')}>
                <Input
                  value={data.business_bank_routing_number}
                  onChange={(e) => onChange('business_bank_routing_number', e.target.value)}
                  placeholder={t('form.business_bank_routing_number.placeholder')}
                />
              </Form.Item>
            )}
          </Form>
        </div>
      )}
      {children}
    </Card>
  );
}
